import { Toolbar as BaseToolbar } from '@base-ui/react/toolbar';
import { styled } from '../lib/styled.tsx';
import { controlSurface } from '../lib/surfaces.ts';

const item =
  'inline-flex h-8 items-center justify-center gap-2 rounded-control px-2 ' +
  'text-sm font-medium text-ink-muted select-none outline-none ' +
  'transition-[background-color,color] duration-150 ease-out-quint ' +
  'hover:not-data-disabled:bg-surface-muted hover:not-data-disabled:text-ink ' +
  'data-pressed:bg-surface-muted data-pressed:text-ink ' +
  'data-disabled:cursor-not-allowed data-disabled:opacity-50';

/**
 * A row of controls sharing one tab stop: focus enters the toolbar once and the
 * arrow keys move between the items inside it.
 *
 * `Button` here is the toolbar's own item, not our {@link Button} — it carries
 * the roving-focus wiring. Render other controls (a {@link Toggle}, a
 * {@link Select} trigger) through a toolbar item's `render` prop to keep it.
 */
export const Toolbar = {
  Root: styled(
    BaseToolbar.Root,
    'flex items-center gap-1 rounded-control border border-border-subtle bg-surface p-1 ' +
      'data-[orientation=vertical]:flex-col data-[orientation=vertical]:items-stretch',
  ),
  Button: styled(BaseToolbar.Button, item),
  Link: styled(BaseToolbar.Link, `${item} underline-offset-4 hover:underline`),
  Group: styled(BaseToolbar.Group, 'flex items-center gap-1'),
  Separator: styled(
    BaseToolbar.Separator,
    'shrink-0 bg-border-subtle ' +
      'data-[orientation=vertical]:mx-1 data-[orientation=vertical]:h-5 data-[orientation=vertical]:w-px ' +
      'data-[orientation=horizontal]:my-1 data-[orientation=horizontal]:h-px data-[orientation=horizontal]:w-full',
  ),
  Input: styled(BaseToolbar.Input, `${controlSurface} h-8 w-auto`),
};
